import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const decisionAPI = createApi({
  baseQuery,
  reducerPath: 'decisionAPI',
  endpoints: builder => ({
    getdecisionData: builder.query<any, any>({
      query: ({ site_id, study_id }) => ({
        url: formatString(
          endPoints.conductDecisionLog.getAll,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        ),
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const { useGetdecisionDataQuery } = decisionAPI;
